import RightMenu from '@components/RightMenu';
import React, { useEffect, useState } from 'react';
import styles from "./AccountGift.module.scss"
import classNames from 'classnames/bind';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import { getUserQuery } from 'dataLayer/user';
import BackIcon from '@components/svg/BackIcon';
import CustomTable from './CustomTable';
import { Button, Col, DatePicker, Input, Row, Select } from 'antd';


const cx = classNames.bind(styles)
const { RangePicker } = DatePicker
const { Option } = Select;


function AccountGift() {
	const { data: user } = useQuery(getUserQuery());
	const { t } = useTranslation();

	const titleTable = [
		{
			id: 'stt', label: `${t('account.gift_page.stt')}`,
			// minWidth: "5%"
			// width: '5%'
		},
		{
			id: 'code', label: `${t('account.gift_page.code')}`,
			// minWidth: 100
			// minWidth: '15%',
			align: 'center',
			format: (value) => value.toLocaleString('en-US'),
		},
		{
			id: 'date',
			label: `${t('account.gift_page.date')}`,

			// minWidth: 170,
			align: 'center',
		},
		{
			id: 'status',
			label: `${t('account.gift_page.status')}`,

			// minWidth: 170,
			align: 'center',
			format: (value) => value.toLocaleString('en-US'),

		},
		{
			id: 'note',
			label: `${t('account.gift_page.note')}`,


			// minWidth: 170,
			align: 'right',
			format: (value) => value.toFixed(2),

		},
	];
	const listSelect = [
		"trúng thưởng", "chờ quay"
	]
	function createData(code, date, status, note) {
		return { code, date, status, note };
	}


	const rows = [
		createData('abcdef1', '21/03/2023', "Trúng thưởng", "Buy package"),
		createData('abcdef2', '21/03/2023', "Trúng thưởng", "Buy package"),
		createData('abcdef3', '21/03/2023', "Trúng thưởng", "Buy package"),
		createData('abcdef4', '21/03/2023', "Trúng thưởng", "Successful bid"),
		createData('abcdef5', '21/03/2023', "Trúng thưởng", "Buy package"),
		createData('abcdef6', '21/03/2023', "Trúng thưởng", "Renew package sub"),
		createData('abcdef7', '21/03/2023', "Trúng thưởng", "Renew package sub"),
		createData('abcdef8', '21/03/2023', "Trúng thưởng", "Renew package sub"),
		createData('abcdef9', '21/03/2023', "Trúng thưởng", "Buy package"),
		createData('abcdef10', '21/03/2023', "Trúng thưởng", "Buy package"),
		createData('abcdef11', '21/03/2023', "Trúng thưởng", "Buy package"),
		createData('abcdef12', '21/03/2023', "Trúng thưởng", "Buy package"),
		createData('abcdef13', '21/03/2023', "Trúng thưởng", "Buy package"),
		createData('abcdef14', '21/03/2023', "Trúng thưởng", "Buy package"),
		createData('abcdef15', '21/03/2023', "Trúng thưởng", "Buy package"),
	];
	const dataGift = {
		data: [
			{
				auction_time: "2023-03-20T05:58:01.000Z",
				image: null,
				isdn: "923****933",
				key: 0,
				name: "923****933",
				status: "1150 pts"
			},
			{
				auction_time: "2023-03-23T05:58:01.000Z",
				image: null,
				isdn: "923****933",
				key: 0,
				name: "923****933",
				status: ""
			},
			{
				auction_time: "2023-03-21T05:58:01.000Z",
				image: null,
				isdn: "923****933",
				key: 0,
				name: "923****933",
				status: "1200 pts"
			},
		],
		pageSize: "10",
		success: true,
		total: 3,
	}
	const [showHelp, setShowHelp] = useState(false)
	const handleHelp = () => {
		setShowHelp(true)
	}
	const closeHelp = () => {
		setShowHelp(false)

	}
	const [width, setWidth] = useState(window.innerWidth);

	function handleWindowSizeChange() {
		setWidth(window.innerWidth);
	}

	useEffect(() => {
		window.addEventListener("resize", handleWindowSizeChange);
		return () => {
			window.removeEventListener("resize", handleWindowSizeChange);
		};
	}, []);

	const isMobile = width <= 768;
	const isMobileMN = width <= 910;
	const isWebOneColumn = width <= 1200;
	const isWeb1400 = width <= 1400;


	return (
		<div className={cx('container', `${isWebOneColumn ? "web-one-column" : ''}`, `${isMobile ? 'mobile' : ''}`, `${isWeb1400 ? 'isWeb1400' : ''}`)}>
			<div >
				{showHelp ?
					(<div className={cx('box-help')}>
						<button onClick={closeHelp} className={cx("btn-back")}> <i><BackIcon /></i>Back</button>
						<p>
							After successfully registering/renewing/retailing the package/ bidding, the subscriber will receive X codes (corresponding to the price).
						</p>
						<div className={cx('content-help')}>
							<p><h3>- Service Registration:</h3> award 10 codes</p>
							<p><h3>- Every time a customer set price:</h3> award 1 code</p>
							<p><h3>- Package Renewal:</h3></p>
							<p><h3>+ Renew daily package:</h3>award 2 codes</p>
							<p><h3>+ Renew weekly package:</h3>award 5 codes</p>
							<p><h3>+ Renew monthly package:</h3>award 10 codes</p>
							<p><h3>- Buying retail packages:</h3></p>
							<p><h3>+ Package of 5 bids:</h3>award 5 codes</p>
							<p><h3>+ Package of 10 bids:</h3>award 10 codes</p>
							<p>How to choose the winner and give a prize?</p>
							<p>Every 2 months, the service will organize a Lucky draw, based on the list of codes given to Customers r and select an unique code.</p>
							<p>The owner of this code will receive a high value prize: airpods, smartphones,....</p>
						</div>
					</div>)
					: (
						<>
							<div className={cx('container-gift', `${isMobileMN ? 'isMobileMN' : ''}`)}>
								<Row justify="center" style={{ width: "100%" }}>
									<Col span={6}>
										<div className={cx("item-field", `${isWeb1400 ? 'isWeb1400' : ''}`)}>
											<h3>{t('account.gift_page.code')}:</h3>
											<div className={cx('input-field')}>
												<Input placeholder={t('account.gift_page.code')} style={{ width: "100%" }} />
											</div>
										</div>
									</Col>
									<Col span={12}>
										<div className={cx("item-field", `${isWeb1400 ? 'isWeb1400' : ''}`)}>
											<h3>{t('account.gift_page.date')}:</h3>
											<div className={cx('input-field')}><RangePicker style={{ width: "100%" }} /></div>
										</div>
									</Col>
									<Col span={6}>
										<div className={cx("item-field", `${isWeb1400 ? 'isWeb1400' : ''}`)}>
											<h3>{t('account.gift_page.date')}</h3>
											<div className={cx('input-field')}>
												<Select
													className={cx('select')}
													placeholder={t('account.gift_page.date')}
													style={{ width: "100%" }}

												>
													{listSelect.map((item, key) => (
														<Option value={item} key={key}>
															{item}
														</Option>
													))}
												</Select>
											</div>
										</div>

									</Col>
								</Row>

							</div>
							<div className={cx('container-gift')}>
								<Row className={cx('container-btn')}>
									<Col span={18}>
										<a onClick={handleHelp}>{t('account.gift_page.link')}</a>
									</Col>
									<Col span={6} >
										<div className={cx('box-btn_search')}>
											<Button className={cx('btn_search')}>{t('account.gift_page.btn_query')}</Button>
											<Button className={cx('btn_search')}>{t('account.gift_page.btn_reset')}</Button>
										</div>

									</Col>
								</Row>
							</div>
							<div className={cx('container-gift')}>
								<div className={cx('box-table')}>
									<CustomTable title={titleTable} rows={rows} />

								</div>
							</div>
						</>
					)}

			</div>
			<RightMenu type="AccountGift" dataGift={dataGift} />
		</div>
	);
}

export default AccountGift;